import React from 'react';
import { Container, Navbar, NavbarBrand } from 'reactstrap';
import { Link } from 'react-router-dom';

const Privacy = () => (
  <>
    <Navbar expand="lg" fixed="top" className="navbar-custom nav-sticky">
      <Container>
        <NavbarBrand tag={Link} to="/" className="logo">
          <p className="scalebased-header mb-0">
            scalebased<strong>.</strong>
          </p>
        </NavbarBrand>
      </Container>
    </Navbar>

    <section className="section" style={{ paddingTop: 160 }}>
      <Container style={{ maxWidth: 760 }}>
        <p className="eyebrow mb-3">Legal</p>
        <h1 className="mb-4">Privacy.</h1>
        <p className="text-muted">
          This Privacy Policy describes the policies and procedures for collection, use and disclosure of your information when you use scalebased&rsquo;s website and services.
        </p>

        <h3 className="mt-5 mb-3">What we collect</h3>
        <p className="text-muted">
          Only what you send us &mdash; the name, email and message you submit through the contact form. We do not run third-party analytics or advertising trackers.
        </p>

        <h3 className="mt-5 mb-3">How we use it</h3>
        <p className="text-muted">
          To reply to your message and, where relevant, follow up on a project or proposal. We do not sell or share your information with third parties.
        </p>

        <h3 className="mt-5 mb-3">Retention &amp; deletion</h3>
        <p className="text-muted">
          Messages are kept only as long as needed to handle your enquiry. You can request deletion at any time by emailing
          {' '}<a href="mailto:mail@scalebased.io">mail@scalebased.io</a>.
        </p>

        <h3 className="mt-5 mb-3">Contact</h3>
        <p className="text-muted">
          Questions about this policy? <a href="mailto:mail@scalebased.io">mail@scalebased.io</a>.
        </p>
      </Container>
    </section>
  </>
);

export default Privacy;
